import { MagnoliaImage } from "@/components/atoms/image/image";

interface CountryData {
  countryName: string;
  countryCode: string;
  displayName: string;
  countryImage: MagnoliaImage | string;
}

const fontConfig = [
  {
    brand: "staysure",
    fontWeightClass: "font-bold",
    fontColorClass: "text-text-accent-1-primary",
    fontFamilyClass: "font-body-font",
  },
  {
    brand: "avanti",
    fontWeightClass: "font-bold",
    fontColorClass: "text-text-body",
    fontFamilyClass: "font-body-font",
  },
];

export function processCountryList(countryList: Record<string, CountryData>) {
  return Object.values(countryList).map((countryData) => {
    const { countryName, countryCode, displayName, countryImage } = countryData;
    const popularCountryImage: MagnoliaImage =
      typeof countryImage === "string"
        ? {
            "@id": "",
            "@link": countryImage,
            "@name": "",
            "@path": "",
            "@type": "",
            "@uuid": "",
          }
        : countryImage;

    const srcImage = `${process.env.NEXT_PUBLIC_MGNL_HOST}/dam/${popularCountryImage["@id"]}${popularCountryImage["@path"]}`;

    return {
      displayLabel: displayName,
      parentCode: countryCode,
      parentName: countryName,
      countryImage: srcImage,
    };
  });
}

export function getFontClasses(lBrand: string | undefined): string {
  let fontClasses = "";
  fontConfig.forEach((config) => {
    if (config.brand === lBrand) {
      fontClasses = `${config.fontColorClass} ${config.fontWeightClass} ${config.fontFamilyClass}`;
    }
  });
  return fontClasses;
}
